import { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import {
  useClassificationBooks,
  useClassifications,
} from "../../features/HomePage/api/client";
import { usePageParam } from "../../hooks/usePageParam";
import BooksPageLayout from "../../features/BooksPage/components/BooksPageLayout/BooksPageLayout";
import ErrorMessage from "../../ui/components/ErrorMessage/ErrorMessage";
import ClassificationsPage from "../ClassificationsPage/ClassificationsPage";

const ClassificationBooksPage: FunctionComponent = () => {
  const { idOrName } = useParams();
  const currentPage = usePageParam();

  const { data: classifications, error: classificationsError } =
    useClassifications();
  const classification = classifications?.find(
    ({ id, classificationName }) =>
      idOrName === id || idOrName === classificationName,
  );

  const {
    data: bookList,
    isLoading,
    error,
  } = useClassificationBooks(
    classification?.classificationName ?? "",
    currentPage,
    15,
  );

  if (classificationsError) {
    return <ErrorMessage />;
  }

  if (!classification) {
    return <ClassificationsPage />;
  }

  const { classificationName } = classification;

  return (
    <BooksPageLayout
      title={classificationName}
      seoTitle={`${classificationName} в Читанці`}
      seoDescription={`Підбірка книжок «${classificationName}» в Читанці`}
      bookList={bookList}
      isLoading={isLoading}
      error={error}
      currentPage={currentPage}
    />
  );
};

export default ClassificationBooksPage;
